/**
 * @generated SignedSource<<7abe43da5e82fd507654cc52acf6bc85>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Page_referral$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ArtistDetails_referral" | "ConfirmAccountInfo_referral" | "PartnerAddCompanyInfo_referral">;
  readonly " $fragmentType": "Page_referral";
};
export type Page_referral$key = {
  readonly " $data"?: Page_referral$data;
  readonly " $fragmentSpreads": FragmentRefs<"Page_referral">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Page_referral",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConfirmAccountInfo_referral"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ArtistDetails_referral"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PartnerAddCompanyInfo_referral"
    }
  ],
  "type": "ReferralInterface",
  "abstractKey": "__isReferralInterface"
};

(node as any).hash = "752dcc731a832d73301f5f4a77655fcc";

export default node;
